<template>
  <div
    v-if="showModal"
    class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center p-4"
  >
    <div class="confirm-dialog max-w-[512px] w-full shadow-lg rounded-md bg-white">
      <h3 class="ml-6 mt-7 mb-5">
        {{ $t('messages.change_password_modal.title') }}
      </h3>
      <p class="b1 ml-6 mr-6 text-zyxel-gray-800">
        {{ $t('messages.change_password_modal.description') }}
      </p>
      <div class="hidden sm:flex justify-end mt-[56px]">
        <button
          class="button-cancel mb-6 px-4 py-2 rounded mr-3"
          @click="stayLoggedIn"
        >
          {{ $t('messages.button.stay_sign_in') }}
        </button>
        <button
          class="button-primary mb-6 mr-6 px-4 py-2 rounded"
          @click="logOutAll"
        >
          {{ $t('messages.button.sign_out_all') }}
        </button>
      </div>
      <div class="flex-col sm:hidden mt-[42px] p-6">
        <button
          class="button-primary w-full mb-4 rounded"
          @click="logOutAll"
        >
          {{ $t('messages.button.sign_out_all') }}
        </button>
        <button
          class="button-cancel w-full rounded"
          @click="stayLoggedIn"
        >
          {{ $t('messages.button.stay_sign_in') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'LogoutModal',
  props: {
    showModal: Boolean
  },
  methods: {
    stayLoggedIn() {
      this.$emit('close-modal');
    },
    logOutAll() {
      const auth = useAuthStore();

      auth.signoutAll();
    }
  }
}
</script>